/**
 * useRegisterPullToRefresh — opt a route into the AppShell's pull-to-refresh.
 *
 * Pass the function you want invoked when the user pulls down. The hook
 * registers it with the AppShell's outlet context for the lifetime of
 * the component, then deregisters on unmount.
 *
 * Example:
 *   useRegisterPullToRefresh(loadAll);
 *
 * No-op when used outside of an AppShell-wrapped route (e.g. detail pages,
 * onboarding) — those screens should use the raw `usePullToRefresh` hook
 * with their own scroll container instead.
 */
import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

export function useRegisterPullToRefresh(handler) {
  // useOutletContext returns null when not nested inside an Outlet — safe.
  const ctx = useOutletContext() || {};
  const register = ctx.registerRefresh;
  useEffect(() => {
    if (!register) return undefined;
    register(handler);
    return () => register(null);
  }, [register, handler]);
}
